import React from 'react';
const MasterContext = React.createContext(null);
export default MasterContext;
